const AIDetectionIcon = ({ size = 15, className = '', strokeWidth = 1.0 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_11755_11189)">
                <path
                    d="M5.17313 7.3976C5.13743 7.25923 5.06531 7.13295 4.96427 7.03191C4.86322 6.93086 4.73695 6.85874 4.59858 6.82304L2.14563 6.19051C2.10378 6.17864 2.06695 6.15343 2.04072 6.11872C2.0145 6.08402 2.00031 6.0417 2.00031 5.9982C2.00031 5.95469 2.0145 5.91238 2.04072 5.87767C2.06695 5.84296 2.10378 5.81776 2.14563 5.80588L4.59858 5.17295C4.7369 5.13729 4.86314 5.06523 4.96418 4.96426C5.06522 4.86329 5.13737 4.73709 5.17313 4.5988L5.80566 2.14585C5.81742 2.10384 5.8426 2.06682 5.87736 2.04046C5.91212 2.01409 5.95455 1.99982 5.99818 1.99982C6.0418 1.99982 6.08424 2.01409 6.119 2.04046C6.15376 2.06682 6.17894 2.10384 6.19069 2.14585L6.82282 4.5988C6.85852 4.73717 6.93064 4.86344 7.03168 4.96449C7.13273 5.06553 7.25901 5.13766 7.39737 5.17335L9.85032 5.80548C9.8925 5.81711 9.9297 5.84227 9.95621 5.87708C9.98272 5.91189 9.99708 5.95444 9.99708 5.9982C9.99708 6.04195 9.98272 6.0845 9.95621 6.11931C9.9297 6.15413 9.8925 6.17928 9.85032 6.19091L7.39737 6.82304C7.25901 6.85874 7.13273 6.93086 7.03168 7.03191C6.93064 7.13295 6.85852 7.25923 6.82282 7.3976L6.19029 9.85054C6.17854 9.89256 6.15336 9.92957 6.1186 9.95594C6.08384 9.9823 6.04141 9.99658 5.99778 9.99658C5.95415 9.99658 5.91172 9.9823 5.87696 9.95594C5.8422 9.92957 5.81702 9.89256 5.80526 9.85054L5.17313 7.3976Z"
                    stroke="currentColor"
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.53308 1.09729H10.7719V3.33613"
                    stroke="currentColor"
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.53308 10.8989H10.7719V8.66008"
                    stroke="currentColor"
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.46301 1.09729H1.22417V3.33613"
                    stroke="currentColor"
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.46301 10.8989H1.22417V8.66008"
                    stroke="currentColor"
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11755_11189">
                    <rect width="11.9965" height="11.9965" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default AIDetectionIcon;
